export default __webpack_public_path__ + "static/media/copy_icon.b4e78f76.svg";